import classNames from "classnames";
import { WidthSimpleButton } from "features/option-controls/measurements-option-controls/components/WidthSimpleButton";
import { ComponentPropsWithoutRef } from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";

const gridVariants = {
  default: {
    className: "gg-grid-cols-2 gg-gap-x-5 sm:gg-grid-cols-3",
    buttonVariant: "mobile-sublayout",
  },
  standing: {
    className: "standing-group-choice-grid gg-gap-x-2",
    buttonVariant: "wrapping-sublayout",
  },
} as const;

type LayoutChoiceGridProps = ComponentPropsWithoutRef<"div"> & {
  layouts: OptionTemplate[];
  selectedLayoutCode: string | undefined;
  onChangeLayout: (layout: OptionTemplate) => void;
  variant?: keyof typeof gridVariants;
};

export const LayoutChoiceGrid = ({
  layouts,
  selectedLayoutCode,
  onChangeLayout,
  variant = "default",
  className,
  ...divProps
}: LayoutChoiceGridProps) => (
  <div
    {...divProps}
    className={classNames(
      "gg-grid gg-w-full gg-gap-y-4",
      gridVariants[variant].className,
      className,
    )}
  >
    {layouts.map((option) => (
      <WidthSimpleButton
        key={option.code}
        onClick={() => onChangeLayout(option)}
        isActive={option.code === selectedLayoutCode}
        variant={gridVariants[variant].buttonVariant}
      >
        {option.name}
      </WidthSimpleButton>
    ))}
  </div>
);
